import React from 'react';
import OmniApplicationRoot from './application';

import { OmniApplicationContextProvider } from '~/application-context';
import Primus from '~/assets/ws';

window.Primus = Primus;

function OmniApplication(props) {
  return (
    <OmniApplicationContextProvider value={props}>
      <link
        href="https://fonts.googleapis.com/css?family=Roboto+Mono|Roboto+Slab|Roboto:300,400,500,700"
        rel="stylesheet"
      />
      <OmniApplicationRoot />
    </OmniApplicationContextProvider>
  );
}

export default OmniApplication;
